module.exports = __webpack_public_path__ + "img/o1.158ac40c.png";